export const DEFAULT_RATE_LIBRARY_RECORDS = [
  {
    Id: 1,
    ActivityName: "PCC (1:4:8) Plain Cement Concrete",
    UOMBase: "Per 100 Cft",
    Category: "Concrete Works",
    UnitEstimateRate: 12000,
    MaterialRows: [
      {
        MaterialSKU: "MAT-CIV-0021",
        MaterialName: "OPC Cement - 50kg Bags",
        MaterialCategory: "Cement",
        Coefficient: 9.5,
        BaseUOM: "Bags",
        AllowableWastage: 2.0,
      },
      {
        MaterialSKU: "MAT-CIV-0033",
        MaterialName: "Chenab Sand / Ret",
        MaterialCategory: "Aggregate/Sand",
        Coefficient: 40.0,
        BaseUOM: "Cft",
        AllowableWastage: 5.0,
      },
      {
        MaterialSKU: "MAT-CIV-0034",
        MaterialName: "Crushed Stone / Bajri / Sargodha",
        MaterialCategory: "Aggregate/Crush",
        Coefficient: 80.0,
        BaseUOM: "Cft",
        AllowableWastage: 4.0,
      },
    ],
  },
  {
    Id: 2,
    ActivityName: "Brickwork (1:6) Cement Mortar",
    UOMBase: "Per 100 Sft",
    Category: "Masonry Works",
    UnitEstimateRate: 8500,
    MaterialRows: [
      {
        MaterialSKU: "MAT-MSN-0011",
        MaterialName: "Red Brick - Standard",
        MaterialCategory: "Masonry",
        Coefficient: 500,
        BaseUOM: "Nos",
        AllowableWastage: 3.0,
      },
      {
        MaterialSKU: "MAT-CIV-0021",
        MaterialName: "OPC Cement - 50kg Bags",
        MaterialCategory: "Cement",
        Coefficient: 1.2,
        BaseUOM: "Bags",
        AllowableWastage: 2.0,
      },
    ],
  },
  {
    Id: 3,
    ActivityName: "RCC Slab (1:2:4)",
    UOMBase: "Per 100 Cft",
    Category: "Concrete Works",
    UnitEstimateRate: 22000,
    MaterialRows: [
      {
        MaterialSKU: "MAT-CIV-0021",
        MaterialName: "OPC Cement - 50kg Bags",
        MaterialCategory: "Cement",
        Coefficient: 15.5,
        BaseUOM: "Bags",
        AllowableWastage: 2.0,
      },
      {
        MaterialSKU: "MAT-CIV-0033",
        MaterialName: "Chenab Sand / Ret",
        MaterialCategory: "Aggregate/Sand",
        Coefficient: 35.0,
        BaseUOM: "Cft",
        AllowableWastage: 5.0,
      },
      {
        MaterialSKU: "MAT-STL-0001",
        MaterialName: "Steel Rebar 12mm",
        MaterialCategory: "Steel",
        Coefficient: 120.0,
        BaseUOM: "Kg",
        AllowableWastage: 1.5,
      },
    ],
  },
  {
    Id: 4,
    ActivityName: "Plaster (1:4) Internal",
    UOMBase: "Per 100 Sft",
    Category: "Plaster Works",
    UnitEstimateRate: 3200,
    MaterialRows: [
      {
        MaterialSKU: "MAT-CIV-0021",
        MaterialName: "OPC Cement - 50kg Bags",
        MaterialCategory: "Cement",
        Coefficient: 2.5,
        BaseUOM: "Bags",
        AllowableWastage: 2.0,
      },
      {
        MaterialSKU: "MAT-CIV-0033",
        MaterialName: "Chenab Sand / Ret",
        MaterialCategory: "Aggregate/Sand",
        Coefficient: 10.0,
        BaseUOM: "Cft",
        AllowableWastage: 5.0,
      },
    ],
  },
];

const STORAGE_KEY = "rate_library_records_data";

export const getRateLibraryRecords = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(DEFAULT_RATE_LIBRARY_RECORDS));
      return DEFAULT_RATE_LIBRARY_RECORDS;
    }
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) && parsed.length > 0 ? parsed : DEFAULT_RATE_LIBRARY_RECORDS;
  } catch (e) {
    return DEFAULT_RATE_LIBRARY_RECORDS;
  }
};

export const saveRateLibraryRecord = (record) => {
  const current = getRateLibraryRecords();
  let updated;
  if (record.Id) {
    updated = current.map((item) =>
      String(item.Id) === String(record.Id) ? { ...record, Id: item.Id } : item,
    );
  } else {
    const nextId = current.length > 0 ? Math.max(...current.map((r) => Number(r.Id) || 0)) + 1 : 1;
    updated = [{ ...record, Id: nextId }, ...current];
  }
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  } catch (e) {
    console.error("Failed to save to localStorage", e);
  }
  return updated;
};

export const deleteRateLibraryRecord = (id) => {
  const current = getRateLibraryRecords();
  const updated = current.filter((item) => String(item.Id) !== String(id));
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  } catch (e) {
    console.error("Failed to delete from localStorage", e);
  }
  return updated;
};
